// extracted by mini-css-extract-plugin
module.exports = {"shoppingButtons":"cover_shopping_buttons-module__shoppingButtons___rxtbj","active":"cover_shopping_buttons-module__active___TM1TX"};